import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
    PROSPECT_PREVIEW_TEAMS,
    getTeamReleaseDate,
    isTeamPreviewAvailable,
    formatReleaseLabel,
    nhlTeamLogoUrl,
} from './teams';
import './ProspectPreview.css';

function teamCardBackground(color) {
    return `linear-gradient(155deg, ${color} 0%, color-mix(in srgb, ${color} 62%, #000) 55%, #0b0d10 100%)`;
}

function ProspectPreview() {
    return (
        <>
            <Helmet>
                <title>2026-2027 NHL Prospect Preview - Hockey Pipeline</title>
                <meta
                    name="description"
                    content="Team-by-team NHL prospect previews for the 2026-2027 season. A new team article unlocks each day in August, released alphabetically."
                />
                <link rel="canonical" href="https://hockeypipeline.com/prospect-preview" />
            </Helmet>
            <Container className="container top-container">
                <Grid container spacing={1} className="prospect-preview-grid">
                    <Grid item xs={12}>
                        <Typography variant="h4" component="h1" className="page-title">
                            2026-2027 NHL Prospect Preview
                        </Typography>
                        <div className="title-underline" />
                        <Typography className="prospect-preview-intro">
                            All 32 NHL teams, one preview at a time. Starting August 1, a new
                            team prospect article unlocks each day in alphabetical order.{" "}
                            <Link to="/how-projections-work#preview">How these projections work</Link>
                        </Typography>
                    </Grid>

                    {PROSPECT_PREVIEW_TEAMS.map((team, index) => {
                        const available = isTeamPreviewAvailable(index);
                        const releaseDate = getTeamReleaseDate(index);
                        const cardClassName = `prospect-preview-card ${
                            available
                                ? 'prospect-preview-card--available'
                                : 'prospect-preview-card--locked'
                        }`;
                        const cardStyle = { background: teamCardBackground(team.color) };
                        const cardBody = (
                            <>
                                <img
                                    src={nhlTeamLogoUrl(team.abbr)}
                                    alt=""
                                    aria-hidden="true"
                                    className="prospect-preview-logo"
                                />
                                {!available && (
                                    <div className="prospect-preview-lock" aria-hidden="true">
                                        <LockOutlinedIcon className="prospect-preview-lock-icon" />
                                    </div>
                                )}
                                <div className="prospect-preview-copy">
                                    <Typography className="prospect-preview-name">
                                        {team.name}
                                    </Typography>
                                    {!available && (
                                        <Typography className="prospect-preview-status prospect-preview-status--locked">
                                            {`Coming on ${formatReleaseLabel(releaseDate)}`}
                                        </Typography>
                                    )}
                                </div>
                            </>
                        );

                        return (
                            <Grid item xs={6} sm={4} md={3} lg={2} key={team.id}>
                                {available ? (
                                    <Link
                                        to={`/prospect-preview/${team.id}`}
                                        className={cardClassName}
                                        style={cardStyle}
                                    >
                                        {cardBody}
                                    </Link>
                                ) : (
                                    <div className={cardClassName} style={cardStyle}>
                                        {cardBody}
                                    </div>
                                )}
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </>
    );
}

export default ProspectPreview;
